/*
  MessageReportRequest.js - Handles Search for Message Report Data
*/

// OUR MODULES
import config from '../Config';
import RequestRabbit from './RequestRabbit';

const useReplyReportRequest = () => {
  const getReplyReportsData = async (searchObject, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/reports/reply`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'POST',
        body: JSON.stringify(searchObject) || null,
        headers: headers,
      };
      // Request data
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      // Response
      if (response.status > 399 && response.status < 600) {
        errorHandler(responseJSON.error);
        return { results: [], pageCount: 0 };
      }
      return responseJSON;
    } catch (e) {
      errorHandler(e);
      return { results: [], pageCount: 0 };
    }
  };

  const getSingleReplyData = async (replyId, entryType, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/reports/reply/${replyId}`;

      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      // Response
      if (response.status > 399 && response.status < 600) {
        errorHandler(responseJSON.error);
        return null;
      }
      return responseJSON;
    } catch (e) {
      errorHandler(e);
      return null;
    }
  };

  return {
    getReplyReportsData,
    getSingleReplyData,
  };
};

export default useReplyReportRequest;
